import React, { FC } from "react";
import { useSelector } from "react-redux";
import { ThemeProvider, useMediaQuery } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";

// Load roboto font for entire application
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

// Get theme definitions
import { darkTheme, lightTheme } from "config/Themes";
import { VictoryThemeProvider } from "@inode/multi-table-explorer";
import { ApplicationState } from "#store/types";

export const AppThemeProvider = ({ children }: React.PropsWithChildren) => {
    const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
    const type = useSelector((state: ApplicationState) => state.uiState.theme);

    function getTheme() {
        if (type === "DARK") {
            return darkTheme;
        } else if (type === "LIGHT") {
            return lightTheme;
        } else if (type === "OS") {
            return prefersDarkMode ? darkTheme : lightTheme;
        } else {
            return lightTheme;
        }
    }

    return (
        <ThemeProvider theme={getTheme()}>
            <CssBaseline />
            <VictoryThemeProvider>{children}</VictoryThemeProvider>
        </ThemeProvider>
    );
};
